import { injectIntl } from "react-intl";
import {
  Column,
  Container,
  Row,
  ActionBar,
  Heading,
  apiShape,
  browserShape,
  intlShape,
  notifierShape,
  userShape,
  withApi,
  withBrowser,
  withNotifier,
  withUser,
  isNothing,
  parseIntlNumber,
} from "lcm-iot-commons";
import { BadRequestError } from "lcm-iot-commons/client/lib/api/errors";
import moment from "moment";
import TaxForm from "./TaxForm";

type OwnProps = {
  api: apiShape;
  browser: browserShape;
  intl: intlShape;
  notifier: notifierShape;
  user?: userShape;
};

const defaultProps: Partial<OwnProps> = {
  user: undefined,
};

type Props = OwnProps & typeof defaultProps;

export function TaxCreate({ api, browser, intl, notifier, user }: Props) {
  const controllingDirector = (user as $TSFixMe)?.userRoles?.find(
    (ur: $TSFixMe) => ur.name === "controlling_director",
  );
  if (user && isNothing(controllingDirector)) {
    browser.navigateTo("/403");
  }

  const handleOnSubmit = async (values: $TSFixMe, actions: $TSFixMe) => {
    try {
      const newTax = {
        start_date: moment(values.startDate).format("YYYY-MM-DD"),
        end_date: values.endDate
          ? moment(values.endDate).format("YYYY-MM-DD")
          : null,
        country_code: values.country.code,
        rate: parseIntlNumber(values.rate),
        type: values.type.id,
      };

      await api.post("/taxes", newTax);
      notifier.showSuccess(
        intl.formatMessage({ id: "taxes.create_success_notification" }),
      );
      browser.navigateTo("/taxes/");
    } catch (error) {
      if (
        error instanceof BadRequestError &&
        // @ts-expect-error TS(2345) FIXME: Argument of type '"start_date"' is not assignable ... Remove this comment to see the full error message
        error.contains("overlap", "start_date")
      ) {
        actions.setErrors({
          endDate: intl.formatMessage({ id: "api.error.taxes_overlap" }),
          startDate: intl.formatMessage({ id: "api.error.taxes_overlap" }),
        });
      } else {
        notifier.showError(api.translateError(error));
      }
    } finally {
      actions.setSubmitting(false);
    }
  };

  return user ? (
    <Container>
      <Row>
        <Column>
          <ActionBar>
            <Heading title={intl.formatMessage({ id: "taxes.create_tax" })} />
          </ActionBar>
        </Column>
      </Row>
      <Row>
        <Column>
          <TaxForm onSubmit={handleOnSubmit} />
        </Column>
      </Row>
    </Container>
  ) : null;
}

TaxCreate.defaultProps = defaultProps;

export default withUser(
  withApi(withBrowser(withNotifier(injectIntl(TaxCreate)))),
);
